import React from 'react';
// @mui
import { Container } from '@mui/material';
//
import { Helmet } from 'react-helmet-async';
import config from '../config';
// components
import AdminDashboardContent from './dashboard/AdminDashboardContent';
//
import Preloader from '../components/Preloader';
import PartnerDashboardContent from './dashboard/PartnerDashboardContent';
import MerchantDashboardContent from './dashboard/MerchantDashboardContent';
import UserDashboardContent from './dashboard/UserDashboardContent';

// ----------------------------------------------------------------------

export default class DashboardAppPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            // permissions: {},
            isLoading: true
        };
    }
    componentDidMount() {
        const { server } = this.props.context.getState();
        // Promise.all([server.users.dashboardInfo(), server.users.metaInfo()]).then(
        //     ([data, metaInfo]) => {
        //         this.setState({
        //             data: data,
        //             permissions: metaInfo?.permissions || {},
        //             isLoading: false
        //         });
        //     }
        // );

        server.users.dashboardInfo().then((data) => {
            this.setState({
                data: data,
                isLoading: false
            });
        });
    }

    render() {
        if (this.state.isLoading) {
            return <Preloader />;
        }

        // ecoo, merchant, partner, user;
        const systemRole = localStorage.getItem('systemRole');

        return (
            <>
                <Helmet>
                    <title> Dashboard | {config.title} </title>
                </Helmet>

                <Container maxWidth={false}>
                    {systemRole === "ecoo" && <AdminDashboardContent {...this.props} data={this.state.data} />}
                    {systemRole === "partner" && <PartnerDashboardContent {...this.props} data={this.state.data} />}
                    {systemRole === "merchant" && <MerchantDashboardContent {...this.props} data={this.state.data} />}
                    {systemRole === "user" && <UserDashboardContent {...this.props} data={this.state.data} />}
                </Container>
            </>
        );
    }
}
